let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hfJvO")).then(() => parcelRequire('gvs5F'));